var map = {
	"./$GMUSIC-icon.png": 1017,
	"./BAT-icon.png": 1018,
	"./BTC-icon.png": 1019,
	"./BXC-icon.png": 1020,
	"./CC-icon.png": 1378,
	"./DEAD-icon.png": 1379,
	"./DEAD[ETH]-icon.png": 1380,
	"./DEAD[GYRI]-icon.png": 1381,
	"./DistTest-icon.png": 1382,
	"./ETH-icon.png": 1021,
	"./ETIME-icon.png": 1383,
	"./ETIME[GYRI]-icon.png": 1384,
	"./GALA-icon.png": 665,
	"./GALA[ETH]-icon.png": 1385,
	"./GALA[GYRI]-icon.png": 1386,
	"./GSUPER-icon.png": 1387,
	"./GUSDC-icon.png": 1388,
	"./GUSDT-icon.png": 1389,
	"./GVGX-icon.png": 1390,
	"./GWBTC-icon.png": 1391,
	"./GWETH-icon.png": 1392,
	"./GalaChips-icon.png": 1393,
	"./GalaChips[GYRI]-icon.png": 1394,
	"./MTRM-icon.png": 1395,
	"./MTRM[ETH]-icon.png": 1396,
	"./MTRM[GYRI]-icon.png": 1397,
	"./NODETESTCOIN-icon.png": 1398,
	"./NODETESTCOIN-transparent-icon.png": 1399,
	"./SILK-icon.png": 1022,
	"./SILK[GYRI]-icon.png": 1400,
	"./SUPER-icon.png": 1401,
	"./TANK-icon.png": 1023,
	"./TCTESTCOIN-icon.png": 1402,
	"./TEST-icon.png": 1403,
	"./TOWN-icon.png": 1024,
	"./USD-icon.png": 1404,
	"./USDC-icon.png": 1405,
	"./USDT-icon.png": 1406,
	"./VGX-icon.png": 1407,
	"./WBTC-icon.png": 1408,
	"./WETH-icon.png": 1409,
	"./mastercard-icon.png": 1410,
	"./simplex-icon.png": 1025,
	"./visa-icon.png": 1411
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 660;